import {useCallback} from 'react';

import {useEvent} from 'effector-react';

import {fetchStorages, ProfileStorageLocation} from 'api';
import {fetchCustomsFx} from 'models/documents/gds';

export const useCodeAndStorageFetch = () => {
    const customsData = useEvent(fetchCustomsFx);

    function updateSelectsValues(
        select: {
            address: string;
            id: number;
            name: string;
            number: string;
        }[],
    ) {
        return select.map((i) => ({
            number: i.number,
            value: i.id,
            label: i.name,
        }));
    }

    function updateStorageLocationValues(select: ProfileStorageLocation[]) {
        return select.map((i) => ({
            value: i.id,
            label: i.storageName,
            isDisabled: i.status === 'deactivated',
        }));
    }

    const loadSelectValues = useCallback(async () => {
        const value = await customsData();
        return updateSelectsValues(value);
    }, []);

    const loadStorageLocationValues = useCallback(async () => {
        const valuesArr = await fetchStorages();
        return updateStorageLocationValues(valuesArr.storageLocations);
    }, []);

    return {
        loadSelectValues,
        loadStorageLocationValues,
    };
};
